// based on rc-image 4.3.2
import Image from './src/Image';
export * from './src/Image';
export default Image;
